import { Lang as ILang } from '@types';

export class LangModel implements ILang {
    id: number;
    nazov: string;
    skratka: string;
    poradie: string;
    visible: string;

    constructor({ id, nazov, skratka, poradie, visible }: ILang) {
        this.id = id;
        this.nazov = nazov;
        this.skratka = skratka;
        this.poradie = poradie;
        this.visible = visible;
    }
}
